<template>
    <modal @close="$emit('close')" ref="modal">
        <template v-slot:title>{{ browsersOnly ? 'Trusted browsers' : 'Other sessions' }}</template>

        <slot>
            <div data-test="sign-out-others">
                <p v-if="browsersOnly">
                    Your other sessions were signed out when your password changed.
                    Also forget your trusted browsers?
                </p>
                <p v-else>Also sign out your other sessions? You'll stay signed in here.</p>

                <button-row>
                    <button type="button" class="btn btn-outline-primary" data-test="sign-out-others-no" @click.prevent="close">Not now</button>
                    <button type="button" class="btn btn-primary" data-test="sign-out-others-yes" :disabled="busy" @click.prevent="signOut">
                        {{ browsersOnly ? 'Forget them' : 'Sign them out' }}
                    </button>
                </button-row>
            </div>
        </slot>
    </modal>
</template>

<script>
import api from '@/api'
import bus from '@/bus'
import ModalMixin from '@/mixins/ModalMixin'
import { report } from './mfaHelpers'

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`

// Offered after a password change and after turning MFA on or off. The server
// always keeps this session, so it's safe in the app too.
export default {
    mixins: [ModalMixin],
    emits: ['signed-out'],
    data() {
        return {
            browsersOnly: false,
            busy: false,
        }
    },
    methods: {
        // browsersOnly: the other sessions are already gone (a password change)
        ask({browsersOnly = false} = {}) {
            this.browsersOnly = browsersOnly
            this.busy = false
            this.open()
        },
        signOut() {
            this.busy = true
            api.post('/account/sign-out-other-sessions', {}).then((resp) => {
                this.busy = false
                bus.showInfo(this.browsersOnly
                    ? `Forgot ${plural(resp.browsers_forgotten, 'trusted browser')}.`
                    : `Signed out of ${plural(resp.sessions_ended, 'other session')}.`)
                this.$emit('signed-out', resp)
                this.close()
            }).catch((err) => {
                this.busy = false
                report(err)
            })
        },
    },
}
</script>
